import { Box, Container, Typography, styled } from "@mui/material";
import {
  Button,
  Chips,
  Color,
  SimpleInput,
} from "@axismaxlife/unified-ui-components-library";
import { useContext, useEffect, useState } from "react";
import { PageTitle } from "../../../commanComponents/PageTitle";
import { JourneyProgressStepper } from "../../../commanComponents/JourneyProgressStepper";
import { String } from "../../../constants/Strings";
import { useNavigate } from "react-router-dom";
import { fonts } from "../../../style";
import { AppToast } from "../../../commanComponents/AppToast";
import { YearInput } from "../../../commanComponents/YearInput";
import { amountInWords } from "../../../logic/NumberToWord";
import { AuthContext } from "../../../Hooks/context/AuthContext";
import { DataContext } from "../../../Hooks/context/ChildData";
import { useLocalStorage } from "../../../logic/LocalStorage/LocalStorage";
import { gaCustomEvent } from "../../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../../Hooks/context/OTPVeriryContext";

const StyledQuestionTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "1rem",
  fontFamily: fonts.manrope,
  fontWeight: 700,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const toDigits = (raw) => `${raw ?? ""}`.replace(/[^0-9]/g, "");

const requiredLabel = (text) => (
  <>
    {text}{" "}
    <Box component="span" aria-hidden="true" sx={{ color: Color.Text.Error }}>
      *
    </Box>
  </>
);

const InvestmentGoal = () => {
  const goalsButtons = [
    { name: String.Retirement.FutureGoal.buttomName.b1 },
    { name: String.Retirement.FutureGoal.buttomName.b2 },
    { name: String.Retirement.FutureGoal.buttomName.b3 },
    { name: String.Retirement.FutureGoal.buttomName.b4 },
    { name: String.Retirement.FutureGoal.buttomName.b5 },
  ];

  const [active, setActive] = useState(null);
  const [finaicalGoalMoney, setfinaicalGoalMoney] = useState("");
  const [years, setyears] = useState("");
  const [goalName, setGoalName] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarmessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });

  const navigation = useNavigate();
  const { collectedData, collectData } = useContext(DataContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { saveLocalFinancialData, retrieveLocalFinancialData } =
    useLocalStorage();
  const { authTokens } = useContext(AuthContext);

  const { userId } = authTokens;

  const validate = () => {
    let isValid = true;
    const newErrors = {
      goalName: "",
      finaicalGoalMoney: "",
      years: "",
    };

    if (!goalName) {
      newErrors.goalName = String.Retirement.SecondInning.selectGoal;
      isValid = false;
    }

    if (
      !finaicalGoalMoney ||
      isNaN(finaicalGoalMoney) ||
      finaicalGoalMoney <= 0
    ) {
      isValid = false;
    }

    if (!years || isNaN(years) || years <= 0) {
      isValid = false;
    }

    return isValid;
  };
  const showSnackbar = (message, severity) => {
    setSnackbarMessage({ message, severity });
    setSnackbarOpen(true);
  };

  useEffect(() => {
    const retriveData = async () => {
      try {
        const data = await retrieveLocalFinancialData(
          `investmentgoal-${userId}`,
        );

        if (data) {
          setfinaicalGoalMoney(data.finaicalGoalMoney);
          setyears(data.years);
          const isKnownGoal = goalsButtons.some(
            (goalButton) => goalButton.name === data.goalName,
          );
          setGoalName(isKnownGoal ? data.goalName : "");
          setActive(isKnownGoal ? data.active : null);
        }
      } catch (error) { }
    };
    retriveData();
    window.scrollTo(0, 0);
  }, []);

  const onHandleClick = (index, goalName) => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioOtherFinancialGoals,
      verifyData.customerId,
    );
    setActive(index);
    setGoalName(goalName);
  };

  const handleContineu = async () => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioOtherFinancialGoalsContinue,
      verifyData.customerId,
    );
    if (active === null) {
      showSnackbar(
        String.Retirement.FutureGoal.selectGoalerrorMessage,
        String.ErrorSeverity,
      );
      return;
    }

    if (!validate()) {
      showSnackbar(
        String.Retirement.FutureGoal.goalAmountorNumberYear,
        String.ErrorSeverity,
      );
    } else {
      collectData({
        ...collectedData,
        investment: { finaicalGoalMoney, years, goalName },
      });
      saveLocalFinancialData(`investmentgoal-${userId}`, {
        finaicalGoalMoney,
        years,
        goalName,
        active,
      });

      navigation(String.navigations.retirementgoal);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
      }}
    >
      <Container sx={{ flexGrow: 1 }}>
        <PageTitle />
        <JourneyProgressStepper />
      </Container>
      <Container sx={{ textAlign: "left" }}>
        <StyledQuestionTypography variant="body1">
          {requiredLabel(String.Retirement.FutureGoal.question1)}
        </StyledQuestionTypography>
        <Box sx={{ mt: "12px" }}>
          <Chips
            key={goalName || "none"}
            device="mobile"
            layout="multipleRows"
            items={goalsButtons.map((goalButton) => ({
              label: goalButton.name,
            }))}
            defaultSelected={goalName ? [goalName] : []}
            onChange={(selectedChips) => {
              const chosen = (selectedChips || []).find(
                (chip) => chip.selected,
              );
              if (!chosen) {
                setGoalName("");
                setActive(null);
                return;
              }
              onHandleClick(
                goalsButtons.findIndex(
                  (goalButton) => goalButton.name === chosen.label,
                ),
                chosen.label,
              );
            }}
          />
        </Box>

        <Box sx={{ mt: "24px" }}>
          <StyledQuestionTypography variant="body1" sx={{ mb: "12px" }}>
            {requiredLabel(String.Retirement.FutureGoal.question2)}
          </StyledQuestionTypography>
          <SimpleInput
            name="financialGoalMoney"
            type="number"
            indianNumberFormat
            prefix="₹"
            width="100%"
            label={String.Retirement.FutureGoal.goalAmountPlaceholder}
            placeholder={String.Retirement.FutureGoal.goalAmountPlaceholder}
            value={
              !finaicalGoalMoney || finaicalGoalMoney === "0" || finaicalGoalMoney === 0
                ? ""
                : toDigits(finaicalGoalMoney)
            }
            hintText={amountInWords(finaicalGoalMoney)}
            onChange={(e) => setfinaicalGoalMoney(toDigits(e.target.value))}
          />
        </Box>

        <Box sx={{ mt: "24px" }}>
          <StyledQuestionTypography variant="body1" sx={{ mb: "12px" }}>
            {requiredLabel(String.Retirement.FutureGoal.question3)}
          </StyledQuestionTypography>
          <YearInput
            name="goalYears"
            label={String.Retirement.FutureGoal.goalAountYear}
            value={years}
            onChange={setyears}
          />
        </Box>
      </Container>
      <Container sx={{ mt: "40px", mb: "24px" }}>
        <Button
          buttonType="primary"
          width="100%"
          disabled={
            !goalName || !toDigits(finaicalGoalMoney) || !toDigits(years)
          }
          onClick={handleContineu}
        >
          {String.continue}
        </Button>
      </Container>
      <AppToast
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        severity={snackbarmessage.severity}
        message={snackbarmessage.message}
      />
    </Box>
  );
};

export default InvestmentGoal;
